export default __webpack_public_path__ + "static/media/war-began.74a2c1fb.png";